export enum FrequencyStatusEnum {
  Drafted = 1,
  NeedsStaffed = 2,
  NeedsPerformed = 3,
  Performing = 4,
  Performed = 5,
  PendingMissedVisit = 6,
  Missed = 7,
  DiscontinueDrafted = 8,
  Discontinued = 9
}

export const FrequencyStatusOptions = [
{ id: 1, label: 'Drafted', canBeStarted: false, canBeDiscontinued: false, canBeEdited: true, canBeRescheduled: false, isInEffect: false, isPendingOnSchedule: false },
{ id: 2, label: 'Needs Staffed', canBeStarted: false, canBeDiscontinued: true, canBeEdited: false, canBeRescheduled: true, isInEffect: true, isPendingOnSchedule: true },
{ id: 3, label: 'Needs Performed', canBeStarted: true, canBeDiscontinued: true, canBeEdited: false, canBeRescheduled: true, isInEffect: true, isPendingOnSchedule: true },
{ id: 4, label: 'Performing', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: false, isInEffect: true, isPendingOnSchedule: false },
{ id: 5, label: 'Performed', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: false, isInEffect: true, isPendingOnSchedule: false },
{ id: 6, label: 'Pending Missed Visit', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: true, isInEffect: false, isPendingOnSchedule: false },
{ id: 7, label: 'Missed', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: false, isInEffect: false, isPendingOnSchedule: false },
{ id: 8, label: 'Discontinue Drafted', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: false, isInEffect: false, isPendingOnSchedule: false },
{ id: 9, label: 'Discontinued', canBeStarted: false, canBeDiscontinued: false, canBeEdited: false, canBeRescheduled: false, isInEffect: false, isPendingOnSchedule: false }
];
